import React, { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import request from '../../../services/Request';
import Swal from 'sweetalert2';
import MaterialTable from 'material-table';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { imageOnError } from '../../../services/method/methods';
import { CloudDownload, CloudDownloadOutlined } from '@material-ui/icons';
import { sortPOS } from '../../../services/method/methods';
import Preket from '../../orders/prekit/Preket';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { ExportToCsv } from 'export-to-csv';
import {
  FormControlLabel,
  RadioGroup,
  Grid,
  Radio,
  Checkbox,
  Button,
  TableRow,
  TableCell,
  TableContainer,
  TableBody,
  Paper,
  Table,
  TableHead,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function MagexMachineInventoryCheck(props) {
  // const [reflesh, setReflesh] = useState(false);
  const id = props.match.params.id;
  const [loading, setLoading] = useState(false);
  const [mc, setMc] = useState([]);
  const [select, setSelect] = useState(null);

  useEffect(() => {
    // check id is md5 or not
    console.log('id', id?.length);
    if (id?.length !== 32) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid URL',
        text: 'Please check the URL and try again.',
      });
      return;
    } else {
      setLoading(true);
      request({
        method: 'post',
        url: '/magex/CheckInventory/',
        data: {
          id: id,
        },
      }).then((res) => {
        console.log('res', res.data);
        setMc(res.data?.machines);
        setLoading(false);
      });
    }
  }, []);

  const checkInventory = async (mc) => {};

  const columns = [
    {
      title: 'Image',
      field: 'image',
      width: '10%',
      render: (rowData) =>
        rowData.img != '' ? (
          <img
            src={`${rowData.img}`}
            style={{ maxWidth: 100, maxHeight: 50 }}
            alt=""
            onError={imageOnError}
          />
        ) : (
          'No image'
        ),
    },
    { title: 'Product Name', field: 'name', editable: 'never' },
    {
      title: 'Product ID',
      field: 'id',
      editable: 'never',
    },
    {
      title: 'Price',
      field: 'price',
      editable: 'never',
    },
    {
      title: 'Stock',
      field: 'qt',
      editable: 'never',
    },
  ];

  return (
    <div>
      {loading && <LoadingIcon />}
      <h2 style={{ marginRight: '20px', marginTop: '20px', marginBottom: '50px' }}>
        Inventory Check
      </h2>
      <div className="d-flex justify-content-center mb-5">
        <Autocomplete
          style={{ width: '300px', marginRight: '30px' }}
          value={select}
          options={mc}
          onChange={(event, value) => {
            setSelect(value);
          }}
          getOptionLabel={(option) =>
            option?.name ? `${option?.id}(${option?.name})` : option?.id
          }
          renderInput={(params) => (
            <TextField {...params} label="Select a machine" variant="outlined" />
          )}
        />
        {/* <Button
          variant="contained"
          color="primary"
          onClick={() => {
            checkInventory(mc);
          }}
        >
          Submit
        </Button> */}
      </div>
      <div>
        <MaterialTable
          columns={columns}
          data={select ? select?.products : []}
          title="Machine Inventory Check"
          options={{
            search: true,
            paging: true,
            // filtering: true,
            exportButton: true,
            pageSize: 20,
            pageSizeOptions: [5, 10, 20, 50, 100],
            exportAllData: true,
            exportFileName: 'Machine Inventory Check',
            sorting: true,
            // headerStyle: {
            //   backgroundColor: '#3f51b5',
            //   color: '#FFF',
            // },
          }}
        />
      </div>
    </div>
  );
}
